import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { navOneClickDeploy } from '@/components/layout/navigation/configNav';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';

const OneClickDeployLayout = () => {
  const { orgId, workspaceId } = useParamWorkspaceId();
  return (
    // <ConsoleLayout
    //   title="One-click Deployment"
    //   navbar={navOneClickDeploy(orgId, workspaceId)}
    // >
      // <div className="pt-8">
        <Outlet />
      // </div>
    // </ConsoleLayout>
  );
};

export default OneClickDeployLayout;
